import { render, staticRenderFns } from "./EditBankAccountDetails.vue?vue&type=template&id=5f004ff6"
import script from "./EditBankAccountDetails.vue?vue&type=script&lang=js"
export * from "./EditBankAccountDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports